class @UI

  @findAndSelf: (selector, context) ->
    $(selector, context).add(context?.filter(selector))

  @setupDatepickers: (context) ->
    @findAndSelf(".datepicker-field", context).each ->
      $element = $(this)

      format  = "M d"
      format += "c yyyy" if $element.data('date-viewmode') != 'doy'

      $element.datepicker(format: format).attr("autocomplete", "off")

  # The Rails.env.test? ERB guards below disabled select2 under the test env
  # only; the webpack bundle always ships the production (select2) branch.
  @setupSelects: (context) ->
    @findAndSelf("select", context).not(".disable-select2").each ->
      $select = $(@)
      opts = {}
      opts.dropdownCssClass = $select.data("select2-dropdown-css-class")
      $select.select2(opts)

  @setSelectWidth: (e, width) ->
    # select2 v4 has no width:"copy" mode; size the select and its rendered
    # container directly (v3 re-applied width via .select2(width:"copy")).
    $e = $(e)
    $e.css(width: "#{width}px")
    $e.next(".select2-container").css(width: "#{width}px")

  @setSelectValue: (e, value) ->
    # v4: set the underlying value and notify select2 via change (v3 was
    # .select2("val", value), which never fired change).
    #
    # Only fire change when the value actually moved. Handlers that set each
    # other's selects (dependent_destroy's row and all-replace selects) settle
    # on a shared value and would otherwise ping-pong change events forever.
    $(e).each ->
      $select = $(this)
      return if $select.val() == value
      $select.val(value).trigger("change")

  @setupLinks: (context) ->
    @findAndSelf("td[data-link_path], td[data-link-path]", context).css("cursor", "pointer").on "click", ->
      window.location.href = $(this).data("link_path") || $(this).data("link-path")
      return false

  @reloadFormOnChange: (path, target, selectors) ->
    selector = selectors.join(",")
    $(document).on "change", selector, ->
      $element = $(this)
      delay 0, ->
        $form = $element.closest("form")
        data = $form.serialize()
        $.get path, data, (html) -> UI.setupSelects $form.find(target).html(html)

  @hideElementsInHiddenTabs: (context) ->
    $(context).closest(".tabbable.disable-hidden-inputs").find(".tab-pane").each ->
      $tab = $(this)
      if $tab.is(":visible")
        # v4 select2 reflects the underlying <select>'s disabled state, so
        # clearing the attribute (above) re-enables the widget too — the v3
        # .select2("enable") sync call on .select2-offscreen is no longer needed.
        $tab.find("input,select,textarea").removeAttr("disabled")
      else
        $tab.find("input,select,textarea").attr(disabled: "disabled")

  @setupDisablingPills: ->
    $(document).on 'shown.bs.tab', (e) ->
      UI.hideElementsInHiddenTabs(e.target)
    $(".nav.nav-pills").each -> UI.hideElementsInHiddenTabs(@)

  @formatDate: (date, format) ->
    parsedFormat = DPGlobal.parseFormat(format)
    DPGlobal.formatDate(date, parsedFormat)
